import { render, staticRenderFns } from "./ModalReportProblem.vue?vue&type=template&id=02e62085&scoped=true"
import script from "./ModalReportProblem.vue?vue&type=script&lang=ts"
export * from "./ModalReportProblem.vue?vue&type=script&lang=ts"
import style0 from "./ModalReportProblem.scss?vue&type=style&index=0&id=02e62085&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e62085",
  null
  
)

export default component.exports